import {Action} from 'redux';
import {
  EDITOR_CONNECTED,
  EDITOR_DISCONNECTED,
  RESET_CODE,
  CHANGE_CODE,
} from './constants';

export interface IEditorAction extends Action {
  type: string;
  payload?: any;
}

export const connectEditor = () => ({
  type: EDITOR_CONNECTED,
});

export const disconnectEditor = () => ({
  type: EDITOR_DISCONNECTED,
});

export const changeCode = (value: string) => ({
  type: CHANGE_CODE,
  payload: {value},
});

export const resetCode = () => ({
  type: RESET_CODE,
});
